import { defineStore } from "pinia"
import { Subject } from "rxjs"
import { ContextMenuItem } from "src/util/classes/contextMenuItem"
import { ContextSource } from "src/util/enums/contextSource"
import { ContextAction } from "src/util/enums/entityType"
import { Counts } from "src/util/types/misc"

export interface TopNavigationStoreType {
  title: string
  titleReference?: string | null
  titleClass?: string
  subtitle?: string
  quickAction?: ContextAction
  disableQuickAction?: boolean
  menuContent: ContextAction[]
  disableMenuContent: ContextAction[]
  showFilterIcon: boolean
  showFilterIconBadge: boolean
  counts: Counts | Record<string, never>
  contextActionClicked: Subject<ContextMenuItem>
  overlayContextActionClicked: Subject<ContextItemSubscription>
  htmlAllowed?: boolean
}

interface ContextItemSubscription {
  item: ContextMenuItem
  source: ContextSource | string
}

export const useTopNavigationStore = defineStore("pinia-topNavigationStore", {
  persist: false,

  state: (): TopNavigationStoreType => ({
    title: "",
    titleReference: undefined,
    titleClass: undefined,
    subtitle: undefined,
    quickAction: undefined,
    disableQuickAction: false,
    menuContent: [],
    disableMenuContent: [],
    showFilterIcon: false,
    showFilterIconBadge: false,
    counts: {},
    contextActionClicked: new Subject(),
    overlayContextActionClicked: new Subject(),
    htmlAllowed: false,
  }),

  actions: {
    setContextAction(item: ContextMenuItem) {
      this.contextActionClicked.next(item)
    },

    setOverlayContextAction(
      item: ContextMenuItem,
      source: ContextSource | string = ContextSource.GENERIC_OVERLAY
    ) {
      this.overlayContextActionClicked.next({ item, source })
    },
  },
})
